var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import styled from 'styled-components';
import { designSchema } from '../../../../../../../contexts/designs/utils';
import { LARGE_BREAKPOINT } from '../../../../../../../utils/constants';
import { TranslatedText } from '../../../../../../atoms/TranslatedText';
import { labelMixin } from '../../styles';
export var Wrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-wrap: wrap;\n  padding: 8px 0;\n  ", ";\n\n  @media (min-width: ", "px) {\n    border-top: none;\n  }\n\n  ", ";\n"], ["\n  display: flex;\n  flex-wrap: wrap;\n  padding: 8px 0;\n  ", ";\n\n  @media (min-width: ", "px) {\n    border-top: none;\n  }\n\n  ", ";\n"])), function (_a) {
    var withBorder = _a.withBorder;
    return withBorder && "border-top: 1px solid var(--border-color)";
}, LARGE_BREAKPOINT, designSchema);
export var TranslatedLabel = styled(TranslatedText)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), labelMixin);
export var Label = styled.span(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", "\n\n  ", ";\n"], ["\n  ", "\n\n  ", ";\n"])), labelMixin, designSchema);
var templateObject_1, templateObject_2, templateObject_3;
